import styles from "../../styles/partials/_popup.scss";
import useAppState from "../providers/AppProvider";
import { useState } from "react";
import PageTitle from "./PageTitle";
import Image from "../widgets/Image";
import CTA from "../widgets/CTA";

Popup.propTypes = {};

function Popup() {
  const [open, toggleOpen] = useState(true);
  const { byTemplate } = useAppState();
  const page = byTemplate("home")[0];
  const headlineImage = page.image3;
  const heroMobile = page.image2 || page.image1;
  if (!page.checkbox1) {
    return null;
  }

  return (
    <div className={`${styles.popup} ${open ? styles.popup_open : ""}`}>
      <div
        className={styles.popup__scrim}
        onClick={() => toggleOpen(false)}
        aria-label="close popup"
      />
      <div className={styles.popup__inner}>
        {open && (
          <button
            className={styles.popup__close}
            onClick={() => toggleOpen(false)}
            aria-label="close popup"
            type="button"
          />
        )}
        {page.image1 && (
          <div className={styles.popup__image}>
            <Image
              src={page.image1}
              alt={page.image1_alt_text}
              align={page.image1_anchor}
            />
          </div>
        )}
        {heroMobile && (
          <div className={styles.popup__image_mobile}>
            <Image
              src={heroMobile}
              alt={page.image2_alt_text || page.image1_alt_text}
              align={page.image2_anchor || page.image1_anchor}
            />
          </div>
        )}
        <div className={styles.popup__textContainer}>
          {headlineImage ? (
            <img
              className={styles.popup__headlineImage}
              src={headlineImage}
              alt={page.image3_alt_text || page.h2 || ""}
            />
          ) : (
            page.h2 && page.h2 !== "" && <PageTitle title={page.h2} />
          )}
          {page.blurb2 && (
            <div
              className={styles.popup__blurb}
              dangerouslySetInnerHTML={{ __html: page.blurb2 }}
            />
          )}
          {page.fieldgroup2 && page.fieldgroup2.length > 0 && (
            <div className={styles.popup__links}>
              {page.fieldgroup2.map((item) => {
                return (
                  <CTA
                    className={styles.popup__link}
                    key={item.id}
                    link={item.h2}
                    text={item.h1}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Popup;
